import React from "react";
import logoImg from "assets/vote/2023superpowers/DESKTOP/Meteor_LOGO.png";
import { METEORURL } from "config/CONSTANTS";

const Logo = () => {
  return (
    <div className="flex items-center">
      <a className="text-black" href={`${METEORURL}/board/all`}>
        <img src={logoImg} alt="米特logo" className="w-[40px] sm:w-[50px]" />
      </a>
    </div>
  );
};

export default Logo;
